import React, { Component } from "react";

import CAvisoPrivacidad from "../../components/Aviso_Privicidad";

// -----------Importar Componentes de Terceros------------------
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


import logo from '../../assets/Imagenes/Aviso_Privacidad/Cuadros.png'
import './css/style.css'


class AvisoPrivacidad extends Component {
  state = {
    Error: '',
  }
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  componentDidMount() {
        this.scrollToTop();

  }

  render() {
    return (
      <Box className='AvisoContenedor'>
        <Container sx={{ padding: '0px !important', maxWidth: '1200px !important' }}>


          <Typography variant='h1' className='textotitulo'>
                        AVISO DE PRIVACIDAD DE  COLUMBA FUNERALES
                  </Typography>

          <Grid container spacing={1} columns={12}>
            <Grid item xs={12} md={9} sx={{ display: 'flex', justifyContent: 'center' }}>
              <CAvisoPrivacidad Title={false} />
            </Grid>
            <Grid item xs={2} md={3}  >
              <Box width='100%' sx={{ display:{xs:'none', sm:'flex'},  justifyContent: 'flex-end' }}>
                <img style={{marginLeft:'100px'}} width='70%' alt="Logo aviso de privacidad" src={logo}></img>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default AvisoPrivacidad;

